import { Button, Card, Space, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { GlobalUserMenu } from "../components/GlobalUserMenu";
import { useUiState } from "../state";

const { Title, Paragraph, Text } = Typography;

export function AgreementPage() {
  const navigate = useNavigate();
  const { lang } = useUiState();
  const isZh = lang === "zh";

  return (
    <div className="login-wrap agreement-page-wrap">
      <div className="global-user-menu-corner">
        <GlobalUserMenu />
      </div>
      <Card className="glass-card login-card">
        <Space direction="vertical" size={12} style={{ width: "100%" }}>
          <Button icon={<ArrowLeftOutlined />} type="link" onClick={() => navigate('/chat')}>
            {isZh ? "返回" : "Back"}
          </Button>
          <Title level={3} style={{ marginBottom: 0 }}>
            {isZh ? "阅读协议（登录前确认）" : "Reading Agreement (Before Sign-in)"}
          </Title>
          <Paragraph type="secondary">
            {isZh
              ? "本协议旨在明确工具边界与使用责任，保障你在获得高价值合规辅助的同时，清晰了解最终决策归属。"
              : "This agreement defines product boundaries and responsibilities, so you can use high-value compliance assistance with clear decision ownership."}
          </Paragraph>

          <Title level={5}>{isZh ? "1) 工具价值与用途" : "1) Product value and purpose"}</Title>
          <Paragraph>
            {isZh
              ? "XTool 引用 FDA 公开执法数据（openFDA 同步）及 FTC 等相关公开记录（如官方 RSS 新闻稿）作证据提示，并结合规则与模型提供风险识别与宣称改写建议；数据源持续扩充。帮助你提升上架效率、降低高风险表达出现概率。"
              : "XTool cites FDA public enforcement (openFDA sync) and FTC-related public records (e.g., official RSS press releases) as contextual evidence signals, and combines rules and models for risk detection and rewrite guidance; we continuously expand data sources. This helps you ship faster while reducing high-risk phrasing."}
          </Paragraph>

          <Title level={5}>{isZh ? "2) 非百分百保证说明" : "2) Not a 100% guarantee"}</Title>
          <Paragraph>
            {isZh
              ? "XTool 属于合规辅助工具，不构成法律意见、监管审批结论或执法承诺。我们基于公开信息与模型能力提供建议，最终上架与合规责任由用户自行确认。"
              : "XTool is a compliance-assistance product and does not constitute legal advice, regulatory approval, or enforcement commitment. Suggestions are generated from public information and model capabilities; final compliance decisions remain the user's responsibility."}
          </Paragraph>

          <Title level={5}>{isZh ? "3) 使用建议" : "3) Best practice"}</Title>
          <Paragraph>
            {isZh
              ? "对于高风险文案，建议结合人工法务或专业合规团队进行最终复核。对于日常批量文案，XTool 可显著提升筛查与改写效率。"
              : "For high-risk copy, we recommend a final review by legal/compliance professionals. For daily high-volume copy, XTool can significantly improve screening and rewriting efficiency."}
          </Paragraph>

          <Text type="secondary">
            {isZh
              ? "继续登录或注册即表示你已阅读并同意本协议。"
              : "By proceeding to sign in or sign up, you acknowledge that you have read and agreed to this agreement."}
          </Text>
        </Space>
      </Card>
    </div>
  );
}
